import AdsCommonWidget from '@jobseeker/feature-ads/widgets/AdsPanelV2';
import {VersionVariants} from '@jobseeker/lotus/enums';

type AdsHarnessProps = {
  variant: VersionVariants;
  showSmallBadges: boolean;
  showLearningCenterCTA: boolean;
  showFeatured?: boolean;
  showLearning?: boolean;
  showLearnGrow?: boolean;
  showEventOnly?: boolean;
  showFeaturedInstitute?: boolean;
  showRolesAtLeadingBrands?: boolean;
  showPlatinumPartners?: boolean;
  showGoldPartners?: boolean;
  showSalesEvent?: boolean;
  page?: string;
  showWowPlatinumPartners?: boolean;
  showWowGoldPartners?: boolean;
  showWowFeaturedEmployer?: boolean;
};

const AdsHarness = ({variant, ...props}: AdsHarnessProps) => {
  return <AdsCommonWidget variant={variant} {...props} />;
};

export default AdsHarness;
